export default {
  PLAY_AUDIO: 'playAudio'
};
